<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/planned-maintenance/office-job-schedulers"
          ></back-button>
          Add Office Job Scheduler
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Maintenance</li>
          <li class="breadcrumb-item">
            <router-link :to="`/planned-maintenance/office-job-schedulers`"
              >Office Job Schedulers</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <office-job-scheduler-form
              :form="form"
              @attachmentAdded="attachmentAdded"
            ></office-job-scheduler-form>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";
import officeJobSchedulerForm from "./office-job-scheduler-form.vue";

export default {
  components: { officeJobSchedulerForm },
  name: "OfficeJobSchedulerCreate",
  data() {
    return {
      form: {
        job_done_by_id: "",
        job_status: "",
      },
      attachment: "",
      isLoading: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        let office_job_scheduler = await axios.post(
          "/office_job_schedulers",
          this.form
        );
        this.office_job_scheduler = office_job_scheduler.data.data;
        await this.handleFileUpload();
        this.isLoading = false;
        this.$router.push("/planned-maintenance/office-job-schedulers");
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      this.isLoading = true;
      let attachment = this.attachment;
      console.log(attachment);

      const id = this.office_job_scheduler.id;

      let formData = new FormData();
      formData.append("id", id);
      formData.append("attachment", attachment);

      await axios
        .post("upload_office_job_scheduler_attachment", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
      if (this.career_request) {
        this.success = true;
        this.form = [];
      }
      this.isLoading = false;
    },
    attachmentAdded(attachment) {
      this.attachment = attachment;
    },
  },
};
</script>
